import axios from "axios";
import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import interactionPlugin from '@fullcalendar/interaction';
import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import React, { useState, useEffect, useRef } from "react";
import {baseUrl, userLocation, ipAddress, userName} from './Univ.js'

function Home(){
    const [faqData,setfaqData]=useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const currentDate = new Date().toLocaleDateString();
    const [labata, setLabData] = useState([]);
    const [labcount, setLabCount] = useState(0);
    const [labcount1, setLabCount1] = useState(0);
    const [totalNewCount, setTotalNewCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    

    const checkUser= localStorage.getItem('user_login');
    const username= localStorage.getItem('username');

  function fetchLabData() {
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';

  const url = `${baseUrl}lab-pay-view/?start_date=${startDateString}&end_date=${endDateString}`;
  axios
    .get(url)
    .then(response => {
      setLabCount(response.data.length);
    })
    .catch(error => {
      console.log(error);
    });

}

  
  useEffect(() => {
   
    fetchLabData();
   
  }, []);

    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-12 col-12 mb-2'>
                <h3 >MIS -  {currentDate}</h3>
                   <div className="row">                    
                    
                    <div className="col-md-3 mt-5">
                        <div className="card border-primary">
                            <h5 className="card-header bg-warning text-white">Lab</h5>
                            <div className="card-body">
                                <h4>{labcount+labcount1}</h4>
                            </div>
                        </div>
                    </div>
                </div>
               </div>
            </div>
            
        </section>
    )
}

export default Home;